/**
 * OEM 渠道后台页面清单(W3 C-G 骨架)—— 侧栏 partnerTree、路由、占位页标题的单一来源。
 * 设计稿 设计-console.md §3「渠道后台页面」;业务实现在 W4(C-H),本波每页只是带标题的空壳。
 * ★路由一律挂在 /partner 下:ProtectedRoute 给 PARTNER_ADMIN 的白名单只放 /partner 前缀。
 */
import type { PartnerPerm } from "./partnerAccess";

export type PartnerPageKey =
  | "overview"
  | "tenants"
  | "credits"
  | "usage"
  | "settlements"
  | "annualFees"
  | "wallet"
  | "brand"
  | "accounts";

export interface PartnerPageDef {
  key: PartnerPageKey;
  url: string;
  title: string;
  /** i18n key(common 命名空间)。 */
  titleKey: string;
  /** 占位页上的一句说明(下一波要做什么)。 */
  description: string;
  /**
   * 进这页需要的渠道权限点(OEM 第二批 A4):侧栏按 /me 的 partnerPerms 过滤,直链无权 → /403。
   */
  requiredPerm: PartnerPerm;
}

export const PARTNER_PAGES: readonly PartnerPageDef[] = [
  {
    key: "overview",
    url: "/partner",
    title: "总览",
    titleKey: "nav.partnerOverview",
    description: "钱包余额、本月消耗、名下租户数与即将到期提醒。",
    requiredPerm: "PORTAL_READ",
  },
  {
    key: "tenants",
    url: "/partner/tenants",
    title: "租户",
    titleKey: "nav.partnerTenants",
    description: "名下租户列表、开户与租户详情。",
    requiredPerm: "TENANT_READ",
  },
  {
    key: "credits",
    url: "/partner/credits",
    title: "划积分",
    titleKey: "nav.partnerCredits",
    description: "从渠道钱包给名下租户划拨积分。",
    requiredPerm: "CREDIT_MOVE",
  },
  {
    key: "usage",
    url: "/partner/usage",
    title: "消耗",
    titleKey: "nav.partnerUsage",
    description: "名下租户的积分消耗报表。",
    requiredPerm: "USAGE",
  },
  {
    key: "settlements",
    url: "/partner/settlements",
    title: "对账单",
    titleKey: "nav.partnerSettlements",
    description: "按月分成对账单(现金结算)。",
    requiredPerm: "SETTLEMENT",
  },
  {
    key: "annualFees",
    url: "/partner/annual-fees",
    title: "年费",
    titleKey: "nav.partnerAnnualFees",
    description: "渠道年费的金额、服务期与缴纳状态(只读)。",
    requiredPerm: "ANNUAL_FEE",
  },
  {
    key: "wallet",
    url: "/partner/wallet",
    title: "钱包",
    titleKey: "nav.partnerWallet",
    description: "渠道钱包余额与流水。",
    requiredPerm: "WALLET_BALANCE",
  },
  {
    key: "brand",
    url: "/partner/brand",
    title: "品牌设置",
    titleKey: "nav.partnerBrand",
    description: "品牌名、logo、域名、客服与人设名。",
    requiredPerm: "PORTAL_READ",
  },
  {
    key: "accounts",
    url: "/partner/accounts",
    title: "账号与角色",
    titleKey: "nav.partnerAccounts",
    description: "本渠道的子账号与角色(渠道管理员 / 财务 / 运营)。",
    requiredPerm: "ACCOUNT_MANAGE",
  },
] as const;
